// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"4e7e5b56","453":"4ab6b6bc","644":"32cbb338"}[chunkId] + ".chunk.js";
};